export default "__VITE_ASSET__Br9FbgyC__"